import React from 'react';
import { certificationsData, educationData } from '../../../data/educationData';
import Reveal from '../../helper/reveal';
import EducationCard from './education-card';
import './education.css';

function Education() {
    return (
        <section className='section education' id='education' aria-labelledby='education-title'>
            <div className='container'>
                <Reveal className='section-head'>
                    <span className='eyebrow'>09 / Education</span>
                    <h2 id='education-title' className='section-title'>Where I studied.</h2>
                </Reveal>

                <ul className='education__list'>
                    {educationData.map((item, index) => (
                        <Reveal as='li' key={item.id} delay={index * 80} className='education__item'>
                            <EducationCard item={item} />
                        </Reveal>
                    ))}
                </ul>

                <Reveal className='education__certs'>
                    <h3>Certifications &amp; training</h3>
                    <ul>
                        {certificationsData.map((cert) => (
                            <li key={cert}>{cert}</li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </section>
    );
}

export default Education;
